type UserSettignsData = any;

const userSettings: UserSettignsData = null;

export default userSettings;
